import http from "./httpService";

class LocaleService {
  async getIPLocation() {
    const response = await http.get("/ip-geolocation");

    return response.data;
  }
}

export default new LocaleService();
